import * as React from 'react';

export default ({ children }) => <>{children}</>;
